import { icon } from '@carvana/helios-styles';
import takeControlImage from '../../../../public/images/take-control.webp';
import takeControlImageLg from '../../../../public/images/take-control-lg.webp';

import useLayoutSize from '../../../hooks/useLayoutSize';
import {
  CarImage,
  Container,
  Title,
  Info,
  LineItem,
  StyledCheckmark,
  Row,
  TextContent
} from './TakeControl.styles';

const TakeControl = () => {
  const { isSm, isMd } = useLayoutSize();
  let image;

  if (isMd) {
    image = takeControlImageLg;
  } else if (isSm) {
    image = takeControlImage;
  } else {
    image = takeControlImage;
  }
  return (
    <Container>
      <CarImage src={image} alt="Take Control" />
      <TextContent>
        <Title>Take control of vehicle ownership</Title>
        <Info>
          Knowing your vehicle's value gives you the power to make informed financial decisions with
          regards to:
        </Info>
        <Row>
          <StyledCheckmark color={icon.primary} />
          <LineItem>Buying and selling vehicles</LineItem>
        </Row>
        <Row>
          <StyledCheckmark color={icon.primary} />
          <LineItem>Maintenance planning</LineItem>
        </Row>
        <Row>
          <StyledCheckmark color={icon.primary} />
          <LineItem>Insurance savings</LineItem>
        </Row>
      </TextContent>
    </Container>
  );
};

export default TakeControl;
